import PlatformHelper from '@sport1/react-elements/PlatformHelper'
import { AspectRatioTypes, ExtendedRadiusType } from '../BaseComponents/Image/ImageInterfaces'

export const shouldRenderNextImage = ({
    imageUrl,
    aspectRatio = '16:9',
    radiusType = 'none',
    width = '100%',
}: {
    imageUrl?: string
    aspectRatio?: AspectRatioTypes
    radiusType?: ExtendedRadiusType
    width?: number | string
}): boolean => {
    if (
        !PlatformHelper.isNextJS ||
        !imageUrl ||
        // added to skip blurring images which wouldn't have many benefits and make the NextImage component more complicated
        !imageUrl.includes('reshape.sport1.de') ||
        imageUrl.includes('0x0') ||
        aspectRatio === 'ORIGINAL' ||
        radiusType === 'circled' ||
        width <= 40
    ) {
        return false
    }

    return true
}
